// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, BaseApiService } from '@fc-core/services/base-api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  OperatorScheduleResponse,
  ScheduleInterface,
  ScheduleOptions,
} from '@fc-core/models/operator-schedule.model';
import { map } from 'rxjs/operators';
import { BackendResponse } from '@fc-core/models/response.model';

@Injectable({ providedIn: 'root' })
@ApiService({})
export class OperatorSchedulesApiService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  loadAll(options: ScheduleOptions): Observable<ScheduleInterface[]> {
    let params = new HttpParams();
    params = params.append('duration__range_lower', options.lower);
    params = params.append('duration__range_upper', options.upper);
    return this.http
      .get<OperatorScheduleResponse>(this.getOperatorUrl(options.currentId), {
        params,
      })
      .pipe(map((res: BackendResponse<ScheduleInterface[]>) => res.results));
  }

  loadAllAvailableVehicles(options: ScheduleOptions): Observable<number[]> {
    let params = new HttpParams();
    params = params.append('duration__range_lower', options.lower);
    params = params.append('duration__range_upper', options.upper);
    return this.http
      .get<
        { id: number }[]
      >(`${this.getBaseUrl()}/operators/${options.currentId}/available-vehicles/`, { params })
      .pipe(map((res: { id: number }[]) => res.map((i) => i.id)));
  }

  loadAllAssignedVehicles(options: ScheduleOptions): Observable<number[]> {
    let params = new HttpParams();
    params = params.append('duration__range_lower', options.lower);
    params = params.append('duration__range_upper', options.upper);
    return this.http
      .get<
        { id: number }[]
      >(`${this.getBaseUrl()}/operators/${options.currentId}/assigned-vehicles/`, { params })
      .pipe(map((res: { id: number }[]) => res.map((i) => i.id)));
  }

  create(event: ScheduleInterface): Observable<ScheduleInterface> {
    return this.http.post<ScheduleInterface>(
      this.getOperatorUrl(event.operator),
      event,
    );
  }

  update(event: ScheduleInterface): Observable<ScheduleInterface> {
    return this.http.patch<ScheduleInterface>(
      this.getOperatorScheduleUrl(event.operator, event.id),
      event,
    );
  }

  delete(event: ScheduleInterface): Observable<number> {
    return this.http
      .delete<number>(this.getOperatorScheduleUrl(event.operator, event.id))
      .pipe(map(() => event.id));
  }

  protected getOperatorUrl(operatorId: number): string {
    return `${this.getBaseUrl()}/operators/${operatorId}/schedule/`;
  }

  protected getOperatorScheduleUrl(
    operatorId: number,
    scheduleId: number,
  ): string {
    return `${this.getBaseUrl()}/operators/${operatorId}/schedule/${scheduleId}/`;
  }
}
